import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import InaccessibleLink from "../shim/inaccessible-link";
import util from "../util/util";

export default function RuleDetailExceptions(props) {
  const exceptions = props.hasOwnProperty(`exceptions`) ? props.exceptions : [];

  return (
    <div>
      <div className="row">
        <div className="col-sm-12">
          <h4 className="page__header">Exceptions</h4>
        </div>
      </div>

      <hr />

      <div className="table-responsive">
        <table className="table table-striped table-bordered table-hover">
          <colgroup>
            <col style={{ width: `1%` }}></col>
            <col style={{ width: `39%` }}></col>
            <col style={{ width: `15%` }}></col>
            <col style={{ width: `15%` }}></col>
            <col style={{ width: `15%` }}></col>
            <col style={{ width: `15%` }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>#</th>
              <th>Time Slot</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Created</th>
              <th>Delete Exception</th>
            </tr>
          </thead>
          <tbody>
            {exceptions === false ? (
              <tr>
                <td>
                  <strong>0</strong>
                </td>
                <td colSpan="5">{util.zeroExceptionsMessage}</td>
              </tr>
            ) : (
              exceptions.map((exception, index) => (
                <tr key={index}>
                  <td>
                    <strong>{index + 1}</strong>
                  </td>
                  <td>{util.returnCleanTimeSlot(exception.timeslot)}</td>
                  <td>
                    {moment(exception.start_date).format(
                      util.dateFormatHumanLong
                    )}
                  </td>
                  <td>
                    {moment(exception.end_date).format(
                      util.dateFormatHumanLong
                    )}
                  </td>
                  <td>
                    {moment(exception.created).format(util.dateFormatHumanLong)}
                  </td>
                  <td>
                    <InaccessibleLink
                      className="text-danger"
                      onClick={() => props.onClickDeleteException(exception)}
                    >
                      <i className="fa fa-trash-o" aria-hidden="true"></i>
                      Delete
                    </InaccessibleLink>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

RuleDetailExceptions.propTypes = {
  onClickDeleteException: PropTypes.func,
  exceptions: PropTypes.oneOfType([PropTypes.array, PropTypes.bool])
};
